<template>
  <li
    class="item active"
    data-pfno="33706"
    data-filter=" method_1 method_2 method_11  cate_11 cate_16 normal is_dev is_design is_plan"
    data-rate="100"
    data-page="1"
    :id="'service_product_'+index"
    @click="open_service_popup(item.id)"
  >
    <div class="card">
      <div class="card-image-container portfolioViewBtn" data-pfno="33706">      
        <img :src="src + item.image" >
      </div>
      <div class="favorite_company" @click.stop="toggle_favorite(item.id,item.favorite )">
        <i v-if="item.favorite" class="fas fa-heart" style="color:red"></i>
        <i  v-else class="far fa-heart"></i>
      </div>

      <div class="card-info-container">
        <div class="card-title">
          <span class="card-title-txt portfolioViewBtn" data-pfno="33706">{{item.name_en}}            
          </span>
          <span  class="card-title-txt portfolioViewBtn"  v-if="item.name">({{item.name}})</span>
        </div>           
      </div>
    </div>
  </li>
</template>

<script>
import EventBus from "@/EventBus.js";
export default {
  props:["item" , "index"],
  methods:{
    open_service_popup(id){
      window.open(`/detail_portfolio/${id}`, '_blank', 'width=700,height=600')
    },
    toggle_favorite(id,favorite){
      if(!localStorage.getItem("login")){alert("관심 등록은 로그인후에 이용이 가능합니다.")}
        if(favorite){
          if(confirm("관심을 해제하시겠습니까? ")){
             this.$http.post("app/toggle_favorite_service",this.qs({"id":id})).then(res=>{      
                this.$toasted.success("관심 해제 되었습니다")   
                EventBus.$emit("favorite_service_list")         
            })
          }
        }else{
          this.$http.post("app/toggle_favorite_service",this.qs({"id":id})).then(res=>{       
            this.$toasted.success("관심 설정 하었습니다. 마이페이지에서 확인할수 있습니다.")  
            EventBus.$emit("favorite_service_list")         
          })
        }
    },
  }
};
</script>

<style scoped lang="scss">
li {
 cursor: pointer;
    width: 252px;
    height: 230px;
    position: relative;
    border-radius: 10px;
    float:left;
    margin: 11px;
  .card {
   
    background: #ffffff;
    height: 100%;
    cursor: pointer;
    .favorite_company{
      top: 20px;
      right: 15px;
      position: absolute;
    }
    .card-image-container {
      height: 116px;
      width: 100%;
      margin-top: 10px;
      img{
        width: 240px;
        height: 120px;
        margin: 3px;
      }
    }
    .card-info-container {
      padding: 14px 12px 0 12px;
      .card-title {
        margin-bottom: 0rem;
        line-height: 1;
        .card-title-txt {
          font-size: 13px;
          font-weight: bold;
          display: inline-block;
          color: #373737;
          white-space: nowrap;    
          width: 170px;
          cursor: pointer;
          line-height: 14px;
        }
      }
      .card-category {
        font-size: 13px;
        color: #f27824;
        margin-top: 5px;
        display: inline-block;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .card-writer {
        font-size: 13px;
        margin-top: 3px;
        color: #85878c;
        .card-writer-name {
          font-weight: bold;
          color: #373737;
          margin-left: 12px;
        }
      }
      .card-type {
        margin-top: 10px;
        color: #85878c;
        font-size: 13px;
      }
      .freelance-container {
        margin-top: 11px;
        .freelacne-skill > span {
          font-size: 11px;
          display: inline-block;
          text-align: center;
          background-color: #828282;
          color: #ffffff;
          padding: 5px 10px;
          line-height: 1;
          border-radius: 3px;
          margin-right: 3px;
          margin-top: 3px;
        }
      }
    }
  }
}
.display-none {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/SPA/Search/Components/PortfolioItem.vue